import { useCallback } from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';

import { useLoginOrSignupPageState } from 'src/app/pages/loginOrSignup/pageContext';

import type { LoginMutationResponse } from '../../../../useLoginOrSignup/api/loginByEmail';

export function useHandleLoginResponseStatus(): (response: LoginMutationResponse) => boolean {
	const [, { setError, clearError, setFormFieldError }] = useLoginOrSignupPageState();
	const { localizeNumber, translate, translatePlural } = useI18n();

	return useCallback(
		(response) => {
			const { status } = response;

			switch (status) {
				case 'LOGGED_IN':
					return true;
				// for staff users who attempt to login without SAML
				case 'INVALID_LOGIN_METHOD':
					setError(translate('corgi.login_or_signup.error.login.invalid_login_method'));
					return false;
				// for users who input passwords that don't match their email addresses provided
				case 'NOT_FOUND':
					clearError();
					setFormFieldError('password', translate('corgi.login_or_signup.error.login.not_found'));
					return false;
				// for users who attempt to login unsuccessfully multiple times
				case 'RATE_LIMITED': {
					const waitInMinutes = 5;
					setError(
						translatePlural('corgi.login_or_signup.error.login.rate_limited_with_plural', waitInMinutes, {
							wait: localizeNumber(waitInMinutes),
						}),
					);
					return false;
				}
				default:
					setError(translate('corgi.login_or_signup.error.network'));
					return false;
			}
		},
		[setError, clearError, setFormFieldError, localizeNumber, translate, translatePlural],
	);
}
